// @flow

import React from 'react';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import { Stepper } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import useIntl from '../../../hooks/useIntl';
import messages from './messages';
import { WIZARD_MODAL_WIDTH_PX } from './constants';
import type { AddGrossRentLimitsWizardProps } from './types';
import Step1 from './Step1';
import Step2 from './Step2';
import { useAddGrossRentLimitsWizard } from './hooks';

const AddGrossRentLimitsWizard = (props: AddGrossRentLimitsWizardProps) => {
  const intl = useIntl();
  const {
    activeStep,
    disabled,
    isEditMode,
    isFirstStep,
    isLastStep,
    isStepOneComplete,
    isSubmitting,
    onBack,
    onClose,
    onContinue,
    reactHookFormProps,
  } = useAddGrossRentLimitsWizard(props);

  return (
    <Modal
      open={props.open}
      onClose={onClose}
      title={intl.formatMessage(
        isEditMode ? messages.editTitle : messages.title,
      )}
      actionsProps={[
        {
          children: isFirstStep
            ? intl.formatMessage(messages.cancel)
            : intl.formatMessage(messages.back),
          onClick: onBack,
          disabled: isSubmitting,
          variant: 'Cancel',
        },
        {
          children: isLastStep
            ? intl.formatMessage(messages.confirm)
            : intl.formatMessage(messages.next),
          onClick: onContinue,
          submitButton: true,
          isSubmitting,
          disabled: isFirstStep ? !isStepOneComplete : false,
        },
      ]}
      ModalProps={{
        PaperProps: {
          sx: {
            width: {
              xs: 'calc(100% - 32px)',
              md: WIZARD_MODAL_WIDTH_PX,
            },
            maxWidth: 'calc(100% - 32px)',
            maxHeight: 'calc(100vh - 100px)',
          },
        },
      }}
      ContentProps={{
        sx: {
          overflowY: 'auto',
        },
      }}
    >
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        steps={[
          {
            label: {
              text: intl.formatMessage(
                isEditMode
                  ? messages.editTitle
                  : messages.stepNewGrossRentLimits,
              ),
            },
          },
          { label: { text: intl.formatMessage(messages.stepConfirmation) } },
        ]}
        sx={{
          width: '100%',
          maxWidth: 350,
          mx: 'auto',
          marginBottom: '16px',
        }}
      />
      {isFirstStep ? (
        <Step1
          reactHookFormProps={reactHookFormProps}
          disabled={disabled}
          open={props.open}
          isEditMode={isEditMode}
          editingChange={props.editingChange}
        />
      ) : (
        <Step2
          open={props.open}
          reactHookFormProps={reactHookFormProps}
          isEditMode={isEditMode}
        />
      )}
    </Modal>
  );
};

export default AddGrossRentLimitsWizard;
